import CalculatorContent from "./CalculatorContent";

export default CalculatorContent;